module.exports = __webpack_public_path__ + "img/line1.d8b64a68.png";